import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import EditClass from "../../EditClass/EditClass";

import { popupContext } from "../../../../contextAdmin/Admin/Popup";
import { listControllerContext } from "../../../../contextAdmin/Admin/List";

import styles from "../style.module.css"
import classRequets from "../../../api/classRequest";
import editIcon from "../TablePng/edit-2.svg"
import trashIcon from "../TablePng/trash-2.svg"
import { userContext } from "../../../../contextAdmin/Admin/User";
export default function ClassRow(props) {
  const navigation = useNavigate();
  const value = props.value;
  const { setPopup } = useContext(popupContext);
  const { list, setList } = useContext(listControllerContext);
  const { user, setUser } = useContext(userContext);
  const [startX, setStartX] = useState(null);
  const [clickActionSensor, setClickActionSensor] = useState(false)
  async function onSubmit(newDetails) {
    let updatedClass = await classRequets.editClassDetails(value.id, newDetails)
    return updatedClass
  }

  async function deleteClick(class_id) {
    let deleteClassRoom = await classRequets.deleteClass(class_id);
  }

  const openEditClassPop = (event) => {
    setPopup(
      <EditClass type={"Edit class"} onSubmit={onSubmit} classId={value.classroomId} classroomName={value.classroomName}>
        Edit class
      </EditClass>
    )
  }

  const deleteClass = (event) => {
    setPopup(
      <EditClass type={"Delete class"} onSubmit={() => { deleteClick(value.id) }} classId={value.classroomId} classroomName={value.classroomName}>
        Delete class
      </EditClass>
    )
  }

  const navigetToStudDetails = () => {
    let path = "/students/" + value.id
    navigation(path, { state: value });
  }
  const handleMouseDown = (event) => {
    setStartX(event.clientX);
  };

  const handleMouseUp = (event) => {
    if (startX === event.clientX && value.students.length) {
      // The user didn't intend to select text, so trigger the click event
      console.log("🚀 ~ handleMouseUp ~ clickActionSensor:", clickActionSensor)
      if (!clickActionSensor) {
        navigetToStudDetails();
      }
    }
  };

  const handleClickSensor = (val) => {
    setClickActionSensor(val);
    console.log("🚀 ~ handleClickSensor ~ clickActionSensor:", clickActionSensor)

  }
  return (
    <>
      {value.classroomName ? (
        <div
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          className={`${styles["rowBox"]} ${value.students.length ? styles["row-select"] : ""}`}>
          <div className={`${styles["rows"]}`}>
            <div className={`${styles["text_row"]}`} >{value.classroomName}</div>
            <div className={`${styles["text_row"]}`} >{value.classroomId}</div>
            <div className={`${styles["text_row"]}`} >{value.students.length}</div>
            <div onMouseLeave={() => { handleClickSensor(false) }} onMouseOver={() => { handleClickSensor(true) }} className={`${styles["text_row"]} ${styles["buttons"]}`}>
              <div onClick={openEditClassPop} >
                <img src={editIcon} alt={"edit"} />
              </div>


              <div onClick={deleteClass}>
                <img src={trashIcon} alt="delete" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
